/**
 * Which dialogs are open, innermost last.
 *
 * Two problems come from the same missing fact. Every mounted sheet bound its
 * own window keydown for Escape, so one keypress closed the sheet *and* the
 * sheet it was opened from. And the keyboard shortcuts only went quiet for
 * INPUT/TEXTAREA/SELECT/contenteditable — but a sheet's panel holds focus
 * itself (tabIndex={-1}), so pressing `c` or `/` inside a half-typed loan
 * form navigated away and took the form with it.
 *
 * A module-level stack rather than a context: the two readers sit on opposite
 * sides of the tree (a sheet deep inside a route, ShortcutsProvider in the
 * layout), both read it synchronously inside a keydown handler, and neither
 * needs to re-render when it changes — so a provider would buy nothing but a
 * wrapper.
 */

let nextId = 1;
const stack: number[] = [];

/** Called by a dialog as it mounts. Keep the id for popDialogLayer. */
export function pushDialogLayer(): number {
  const id = nextId++;
  stack.push(id);
  return id;
}

export function popDialogLayer(id: number): void {
  const at = stack.lastIndexOf(id);
  if (at !== -1) stack.splice(at, 1);
}

/** True only for the sheet on top — the one Escape belongs to. */
export function isTopDialogLayer(id: number): boolean {
  return stack.length > 0 && stack[stack.length - 1] === id;
}

/** Anything modal on screen. Shortcuts stay out of the way while it is. */
export function anyDialogOpen(): boolean {
  return stack.length > 0;
}
